import React, { ReactNode, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import './OverlayCard.css'
interface OverlayCardType {
  overlayComponent: ReactNode;
  triggerComponent: ReactNode;
  placement: 'right' | 'left' | 'bottom' | 'top' | 'bottom-end';
  trigger: 'hover' | 'click' | 'focus';
  show: boolean;
  setShow: (show: boolean) => void;
}

const OverlayCard: React.FC<OverlayCardType> = ({
  triggerComponent,
  overlayComponent,
  placement,
  trigger,
  show,
  setShow,
}) => {
  const handleShow = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    setShow(!show);
  };
  return (
    <OverlayTrigger
      show={show}
      trigger={trigger}
      placement={placement}
      overlay={<div className='overlay_trigger_component'>{overlayComponent}</div>}
    >
      <div  style={{ display: 'inline-block' }} onClick={handleShow}>
        {<>{triggerComponent}</>}
      </div>
    </OverlayTrigger>
  );
};

export default OverlayCard;
